import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { ConfigService } from '../../../services/config.service';
import { CityData } from '../interfaces/city.interface';

@Injectable({
  providedIn: 'root',
})
export class CityService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  getCities() {
    const citiesEndpoint = this.configService.getCitiesEndpoint();
    return this.http
      .get<CityData[]>(citiesEndpoint)
      .pipe(catchError(() => of([])));
  }
}
